export type AppRole =
  | "shipper" | "transporter" | "driver"
  | "ops_admin" | "finance_admin" | "compliance_admin" | "super_admin"
  | "founder_owner";

export const ROLE_PRIORITY: AppRole[] = [
  "founder_owner",
  "super_admin",
  "ops_admin",
  "finance_admin",
  "compliance_admin",
  "transporter",
  "shipper",
  "driver",
];

export const pickEffectiveRole = (roles?: AppRole[] | null): AppRole | null => {
  if (!roles?.length) return null;
  for (const r of ROLE_PRIORITY) if (roles.includes(r)) return r;
  return roles[0] ?? null;
};



export const ROLE_LABELS: Record<AppRole, string> = {
  shipper: "Shipper",
  transporter: "Transporter / Carrier Admin",
  driver: "Driver",
  ops_admin: "Operations Admin",
  finance_admin: "Finance Admin",
  compliance_admin: "Compliance Admin",
  super_admin: "Super Admin",
  founder_owner: "Founder Owner",
};

export const isAdminRole = (r?: AppRole | null) =>
  !!r && ["ops_admin", "finance_admin", "compliance_admin", "super_admin", "founder_owner"].includes(r);

export const isFounder = (r?: AppRole | null) => r === "founder_owner";

export const roleHome = (r?: AppRole | null) => {
  if (!r) return "/app";
  if (r === "shipper") return "/app/shipper";
  if (r === "transporter") return "/app/transporter";
  if (r === "driver") return "/app/driver";
  if (r === "founder_owner") return "/app/founder";
  return "/app/admin";
};
